import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QaTaskTypeConfigurationService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/qatasktypeconfiguration`;

  constructor(private http: HttpClient) { }

  get() {
    return this.http.get<Boo.Qa.QaTaskTypeConfiguration[]>(`${this.baseUrl}/Get`);
  }

  save(config: Boo.Qa.QaTaskTypeConfiguration) {
    return this.http.post<any>(`${this.baseUrl}/Save`, config);
  }
}
